import { useSelector, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import FacetsPanel from '../components/FacetsPanel';
import '../global-sass/variables.scss';
import { radiusChanged } from '../features/facetsSlice';
import { useLocationsData } from '../hooks/useLocationsData';
import { useShowFilterEvent } from '../hooks/useShowFilterEvent';
import { useMakeFacets } from '../hooks/useMakeFacets';
import { useMakeFilter } from '../hooks/useMakeFilter';
import { useResetMakeFilter } from '../hooks/useResetMakeFilter';
import { usePortalContainer } from '../hooks/usePortalContainer';
import { useRadiusSync } from '../hooks/useRadiusSync';

const Widget = () => {
	const radius = useSelector((state) => state.facets.radius);
	const makes = useSelector((state) => state.make.makes);
	const selectedMakes = useSelector((state) => state.make.selectedMakes);
	const portalContainer = usePortalContainer();
	const dispatch = useDispatch();
	const { hasLocations, isReady } = useLocationsData();
	const showFilter = useShowFilterEvent();

	const onRadiusChange = useCallback(
		(newRadius) => dispatch(radiusChanged(newRadius)),
		[dispatch]
	);

	// Sync radius with ws-locations-data changes
	useRadiusSync(isReady);

	// Populate make facets from ws-locations-data whenever locations change
	useMakeFacets(isReady);

	// Bridge Redux selectedMakes → LocationsData.setFilters()
	useMakeFilter(isReady);

	// Reset Make filter when ws-locations-control search Clear button is clicked
	useResetMakeFilter();

	const isRenderPortal = Boolean(portalContainer && showFilter);

	const facetsPanelContent = (
		<FacetsPanel
			radius={radius}
			onRadiusChange={onRadiusChange}
			hasLocations={hasLocations}
			showFilter={showFilter}
			makes={makes}
			selectedMakes={selectedMakes}
			className={isRenderPortal ? 'w-100' : ''}
			isPortal={isRenderPortal}
		/>
	);

	// Renders into a modal
	if (isRenderPortal) {
		return ReactDOM.createPortal(facetsPanelContent, portalContainer);
	}

	return facetsPanelContent;
};

export default Widget;
